module.exports = __webpack_public_path__ + "img/2021-wemlo-TILES-D_FNL_3-03.d39756e1.png";